import { useNavigate } from "react-router-dom";

export default function ComingSoon({ title = "Coming Soon" }) {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.icon}>✨</div>
        <h1 style={styles.title}>{title}</h1>
        <p style={styles.subtitle}>
          We're crafting something beautiful for you. Check back soon!
        </p>

        <button style={styles.button} onClick={() => navigate("/")}>
          Back to Home
        </button>

        <p style={styles.comingSoonText}>Coming Soon</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "calc(100vh - 300px)",
    padding: "40px 20px",
  },

  content: {
    textAlign: "center",
    maxWidth: "500px",
  },

  icon: {
    fontSize: "64px",
    marginBottom: "20px",
    animation: "pulse 2s ease-in-out infinite",
  },

  title: {
    fontSize: "32px",
    fontWeight: "600",
    color: "#2d3748",
    margin: "0 0 15px 0",
    fontFamily: "var(--font-heading)",
  },

  subtitle: {
    fontSize: "16px",
    color: "#718096",
    margin: "0 0 30px 0",
    lineHeight: "1.6",
  },

  button: {
    padding: "14px 32px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(135deg, #C9A14A, #E6C77B)",
    color: "#fff",
    fontWeight: "600",
    fontSize: "16px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    marginBottom: "20px",
  },

  comingSoonText: {
    fontSize: "13px",
    color: "#a0aec0",
    letterSpacing: "2px",
    textTransform: "uppercase",
    margin: 0,
  },
};
